import Vue from 'vue'
import VueRouter from 'vue-router'
import Message from '@views/Message'
import sharedRoutes from './routes'

Vue.use(VueRouter)

const routes = [
  ...sharedRoutes,
  {
    path: '*',
    name: 'not-found',
    component: Message,
    props: {
      title: 'Página não encontrada',
      text: 'Acesse o link enviado para seu e-mail.',
      character: 'cactus'
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: import.meta.env.BASE_URL,
  routes
})

export default router
